export const BASE_URL = '/ops';
export const PARTNER_ROUTE_PATH = BASE_URL + '/partners';
export const NEW_PARTNER_ROUTE_PATH = BASE_URL + '/partners/new';
export const VIEW_PARTNER_ROUTE_PATH = BASE_URL + '/partners/view';
export const FACILITY_ROUTE_PATH = BASE_URL + '/facility';
export const FACILITY_PARTNER_ROUTE_PATH = BASE_URL + '/facility';
export const FACILITY_CLINICIAN_ROUTE_PATH = BASE_URL + '/facility/clinician';
export const NEW_FACILITY_ROUTE_PATH = BASE_URL + '/facility/new';
export const FACILITY_USER_ROUTE_PATH = BASE_URL + '/facility-users/users';
export const FACILITY_NEW_USER_ROUTE_PATH =
  BASE_URL + '/facility-users/users/new';
export const FACILITY_CLINICAIN_MAPPED_LIST_ROUTE_PATH =
  BASE_URL + '/facility/mapped-list';
export const NEW_FACILITY_CLINICIAN_MAPPED_ROUTE_PATH =
  BASE_URL + '/facility/mapped-list/new';

export const FACILITY_CLINICAIN_MAPPING_VIEW_ROUTE_PATH =
  BASE_URL + '/facility/mapping/view';

export const CLINICIANS_ROUTE_PATH = BASE_URL + '/clinicians';
export const NEW_CLINICIANS_ROUTE_PATH = BASE_URL + '/clinicians/new';
export const OPSSTAFF_ROUTE_PATH = BASE_URL + '/opsuser';
export const NEW_OPSSTAFF_ROUTE_PATH = BASE_URL + '/opsuser/new';
export const USER_PROFILE_ROUTE_PATH = BASE_URL + '/profile';
export const INTAKE_ROUTE_PATH = BASE_URL + '/intake';
export const NEW_INTAKE_ROUTE_PATH = BASE_URL + '/intake/new';
export const CONSULTS_ROUTE_PATH = BASE_URL + '/consults';
export const FACILITY_VIEW_ROUTE_PATH = BASE_URL + '/facility/view';
export const FACILITY_USER_VIEW_ROUTE_PATH =
  BASE_URL + '/facility-users/users/view';
export const VIEW_OPSSTAFF_ROUTE_PATH = BASE_URL + '/opsuser/view';
export const VIEW_CLINICIANS_ROUTE_PATH = BASE_URL + '/clinicians/view';
export const NEW_CONSULTS_ROUTE_PATH = BASE_URL + '/consults/new';
export const VIEW_CONSULTS_ROUTE_PATH = BASE_URL + '/consults/view';
export const CONSULTS_MORE_DETAILS_ROUTE_PATH =
  BASE_URL + '/consults/more-details';

export const CLINICAIN_FACILITY_MAPPED_LIST_ROUTE_PATH =
  BASE_URL + '/clinicians/mapped-list';
export const NEW_CLINICAIN_FACILITY_MAPPED_LIST_ROUTE_PATH =
  BASE_URL + '/clinicians/mapped-list/new';

export const VIEW_CLINICAIN_FACILITY_MAPPED_LIST_ROUTE_PATH =
  BASE_URL + '/clinicians/mapping/view';
